module.exports = __webpack_public_path__ + "img/portrait-094.f4394063.jpg";